export default __webpack_public_path__ + "static/media/save-time.259246aa.svg";